import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import './Compliance.css';

function Compliance() {
  useEffect(() => {
    // Track page view with GTM dataLayer
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'page_view',
      page_title: 'Compliance Services - rkube',
      page_location: window.location.href,
      page_path: window.location.pathname
    });
  }, []);

  return (
    <div className="service-page-container">
      <div className="services-page-hero enhanced">
        <div className="container">
          <h1>Stay compliant without the complexity</h1>
          <p className="services-page-description">
            We use AI to track filing deadlines, flag risks, and maintain up-to-date regulatory records. 
            Covering everything from registered agent services to dissolution, sales tax, federal filings, 
            and financial reporting—all in one dashboard.
          </p>
          
          <div className="services-intro">
            <p>From entity formation to ongoing compliance, we help businesses navigate regulatory requirements with confidence, ensuring you stay compliant while focusing on growth.</p>
          </div>
        </div>
      </div>

      <div className="container">
        <div className="service-page-content">
          {/* Service features cards section */}
          <section className="services-features-grid">
            <div className="services-card">
              <div className="services-card-header">
                <div className="services-card-icon green">
                  <span className="icon">👤</span>
                </div>
                <h3>Registered Agent Services</h3>
              </div>
              <p>Professional registered agent services across all 50 states with timely notification of important documents. We ensure you never miss critical legal notices or compliance deadlines.</p>
              <p className="coming-soon">Coming Soon</p>
            </div>

            <div className="services-card">
              <div className="services-card-header">
                <div className="services-card-icon blue">
                  <span className="icon">📄</span>
                </div>
                <h3>Entity Filings</h3>
              </div>
              <p>Streamlined entity formation and maintenance filings. Currently available for North Carolina with expansion plans for additional states.</p>
              <div className="service-action">
                <p className="service-price">One-time filing fee: $100</p>
                <Link to="/filings" className="subscribe-button">
                  Purchase Filing
                </Link>
              </div>
            </div>

            <div className="services-card">
              <div className="services-card-header">
                <div className="services-card-icon purple">
                  <span className="icon">📊</span>
                </div>
                <h3>Compliance Monitoring</h3>
              </div>
              <p>AI-powered compliance tracking and deadline management. Stay ahead of filing requirements with automated alerts and comprehensive compliance calendars.</p>
            </div>

            <div className="services-card">
              <div className="services-card-header">
                <div className="services-card-icon gold">
                  <span className="icon">🔍</span>
                </div>
                <h3>Risk Assessment</h3>
              </div>
              <p>Proactive identification and management of compliance risks. Our system helps you maintain regulatory compliance while minimizing potential penalties.</p>
            </div>
          </section>

          <section className="service-benefits">
            <h2>Benefits</h2>
            <ul className="benefits-list">
              <li>Never miss a filing deadline</li>
              <li>Reduce compliance risk and potential penalties</li>
              <li>Streamline multi-state compliance</li>
              <li>Save time with automated compliance processes</li>
              <li>Get expert guidance on complex regulatory matters</li>
            </ul>
          </section>

          {/* Tools Flexibility Section */}
          <section className="tools-flexibility">
            <h2>Flexible Compliance Solutions</h2>
            <p>Our adaptive approach to compliance means you can choose the services that best fit your business needs.</p>
            
            <div className="tools-options">
              <div className="tool-option">
                <div className="tool-option-icon">
                  <span>🔄</span>
                </div>
                <h3>Use Our Compliance Platform</h3>
                <p>Access our comprehensive compliance dashboard that tracks deadlines, manages documents, and provides real-time compliance status updates.</p>
              </div>
              
              <div className="tool-option">
                <div className="tool-option-icon">
                  <span>⚙️</span>
                </div>
                <h3>Custom Compliance Solutions</h3>
                <p>Need specific compliance services? We can tailor our offerings to your unique requirements, whether it's state-specific filings or industry regulations.</p>
              </div>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
}

export default Compliance; 